import { render, staticRenderFns } from "./TypeOfHeatingFormPart.vue?vue&type=template&id=09b112f6"
import script from "./TypeOfHeatingFormPart.vue?vue&type=script&lang=js"
export * from "./TypeOfHeatingFormPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports